const isNodeInTree = (tree, id) => {
  if (tree.id === id) {
    return true;
  }
  return Boolean(tree.children.find(c => isNodeInTree(c, id)));
};

export default isNodeInTree;
